// extracted by mini-css-extract-plugin
module.exports = {"container":"Sliders_container__2Wu0x","slider":"Sliders_slider__1LPAi","value":"Sliders_value__20rHI"};